import { colors } from '../../../config/theme'

export default {
  floatingLabelFocusStyle: { color: colors.accent },
  underlineFocusStyle: { borderColor: colors.accent },
  errorStyle: { color: colors.error },
  errorText: { color: colors.error }
}



// WEBPACK FOOTER //
// ./src/components/Fields/Dropdown/style.js